import { SimpleFactGroup, SimpleFactCategory } from "@/interfaces";

export const toTopFacts = (group: SimpleFactGroup) => {
  const groupScores = group.scores.map((category) => category.scores).flat();
  const sortedGroupScores = groupScores.sort((a,b) => b.index - a.index);
  const newCategory: SimpleFactCategory = {name: `Top ${group.name}`, scores: sortedGroupScores.slice(0, 10)};
  const newGroup: SimpleFactGroup = {'name': group.name, scores: [newCategory]};
  return newGroup
};
